// @ts-strict-ignore
import CtaButtons from '../CtaButtons'
import { Heading } from '@components/rolex-ui/Heading'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'
import { RolexStorePageV72024 } from '@lib/kontent/models/RolexStorePageV72024'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = {
  isVisible: boolean
  onClose: () => void
  retailer: RolexStorePageV72024
}

const ShopDetails: FC<Props> = ({ isVisible, onClose, retailer }) => {
  const { t } = useTranslation('rolex')

  return (
    <div
      className={cn(
        'absolute inset-0 h-full w-full transition-all duration-150',
        isVisible
          ? 'pointer-events-auto translate-y-0 opacity-100 md:translate-x-0'
          : 'pointer-events-none translate-y-4 opacity-0 md:-translate-x-4',
      )}
    >
      <button
        className="absolute left-0 top-0 h-full w-full border-none bg-transparent outline-none"
        onClick={onClose}
      />
      <div className="absolute bottom-0 left-0 right-0 mx-auto h-auto w-full overflow-hidden bg-rolexShade-100 md:bottom-auto md:right-[initial] md:top-0 md:h-full md:w-[20vw] md:min-w-[410px]">
        <div className="relative h-full w-full overflow-auto text-center md:text-left">
          {retailer && (
            <>
              <div className="hidden md:block">
                {retailer.map_image.value[0] && (
                  <img
                    src={retailer.map_image.value[0].url}
                    alt={retailer.map_image.value[0].description}
                    loading="lazy"
                    className="h-auto w-full"
                  />
                )}
              </div>
              <div className="relative px-[10%] py-10 text-left lg:px-[15%]">
                <button
                  className={cn(
                    'absolute right-[20px] top-[20px] h-[25px] w-[25px] bg-transparent text-rolexShade-900 outline-none transition-colors duration-150',
                    'hover:text-rolexPrimary',
                  )}
                  onClick={onClose}
                >
                  <svg
                    height="11"
                    width="11"
                    viewBox="0 0 11 11"
                    fill="currentColor"
                    className="h-3 w-[14px]"
                  >
                    <path d="m6.9 5.5 4.1 4.1-1.4 1.4-4.1-4.1-4.1 4.1-1.4-1.4 4.1-4.1-4.1-4.1 1.4-1.4 4.1 4.1 4.1-4.1 1.4 1.4z" />
                  </svg>
                </button>
                <Text variant="legend16" className="text-rolexBrown">
                  {t('contact.officialRetailer')}
                </Text>
                <Heading variant="headline30" className="mb-[10px] text-rolexBrown" as="h2">
                  {retailer.name.value}
                </Heading>
                <Text variant="fixed16" weight="light" className="mb-5 whitespace-pre-line sm:mb-8">
                  {retailer.address_details.value}
                </Text>
                <CtaButtons
                  showLabel={true}
                  phoneNumber={retailer.phone_number.value}
                  directionsUrl={retailer.google_maps_link.value}
                  detailSlug={retailer.url_slug.value}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ShopDetails
